import { Icon } from '@components/icon/Icon';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import { ReservationWithDetails } from './apiHelpers';
import styles from './ReservationNote.scss';
import { ReservationNoteModal } from './ReservationNoteModal';

interface ReservationNoteProps {
  reservation: ReservationWithDetails;
}

export const ReservationNote = ({ reservation }: ReservationNoteProps) => {
  const {
    isOpen: isRestaurantNoteModalOpen,
    open: openRestaurantNoteModal,
    close: closeRestaurantNoteModal,
  } = useIsOpen();

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <h2 className={typography.h4}>Reservation Note</h2>
        {reservation.status === 'active' && (
          <button
            className={cx(styles.button, typography.h4)}
            aria-label="Update reservation note"
            type="button"
            onClick={openRestaurantNoteModal}
          >
            <Icon name="pencil" />
          </button>
        )}
      </header>
      {reservation.note && (
        <p className={cx(typography.t1, styles.note)}>{reservation.note}</p>
      )}
      <ReservationNoteModal
        reservationId={reservation.id}
        note={reservation.note}
        isOpen={isRestaurantNoteModalOpen}
        closeModal={closeRestaurantNoteModal}
      />
    </section>
  );
};
